import {
	GET_INCIDENT_TABLE,
	TOGGLE_INCIDENT_TRACKER_DIALOG,
	SET_FORM_STATE,
	SET_CURRENT_QUEUE_DROPDOWN,
	GET_DROPDOWNS,
	GET_ALL_DROPDOWNS,
	GET_PROJECTS_DROPDOWN,
	GET_SOW_DROPDOWN,
	GET_LAYERS_DROPDOWN,
	GET_INCIDENT,
	GET_TYPE_DROPDOWN,
	GET_DETAILED_TYPE_DROPDOWN,
	GET_INCIDENT_COMMENTS,
	GET_INCIDENT_FILES,
	SET_FILES,
	SET_IMAGE
} from '../actions/IncidentTrackerActions';

const initialState = {
	incidentTable: [],
	incidentTrackerDialogVisibility: false,
	selectedIncidentId: 0,
	selectedIncidentSubmitter: '',
	dropdowns: [],
	projectsDropdown: [],
	sowDropdown: [],
	layersDropdown: [],
	typeDropdown: [],
	detailedTypeDropdown: [],
	incidentComments: [],
	incidentFiles: [],
	files: [],
	image: {},
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
		submit: false
	}
};

const incidentTrackerReducer = (state = initialState, action) => {
	switch (action.type) {
					case TOGGLE_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							incidentTrackerDialogVisibility: action.visible,
							selectedIncidentId: action.incidentId,
							selectedIncidentSubmitter: action.incidentSubmitter,
							formState: initialState.formState,
							dropdowns: initialState.dropdowns,
							projectsDropdown: initialState.projectsDropdown,
							sowDropdown: initialState.sowDropdown,
							layersDropdown: initialState.layersDropdown,
							typeDropdown: initialState.typeDropdown,
							detailedTypeDropdown: initialState.detailedTypeDropdown,
							currentQueueDropdown: initialState.currentQueueDropdown,
							incidentComments: initialState.incidentComments,
							incidentFiles: initialState.incidentFiles,
							files: initialState.files,
							image: initialState.image,
						};
					}
					case GET_INCIDENT_TABLE: {
						return {
							...state,
							incidentTable: action.incidentTable
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case SET_FILES: {
						return {
							...state,
							files: action.files
						};
					}
					case SET_IMAGE: {
						return {
							...state,
							image: action.image
						};
					}
					case SET_CURRENT_QUEUE_DROPDOWN: {
						return {
							...state,
							currentQueueDropdown: action.currentQueueDropdown
						};
					}
					case GET_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case GET_ALL_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.allDropdowns.dropdowns,
							projectsDropdown: action.allDropdowns.projects,
							sowDropdown: action.allDropdowns.sow,
							layersDropdown: action.allDropdowns.layers,
							typeDropdown: action.allDropdowns.type,
							detailedTypeDropdown: action.allDropdowns.detailedType
						};
					}
					case GET_PROJECTS_DROPDOWN: {
						return {
							...state,
							projectsDropdown: action.projectsDropdown,
							sowDropdown: initialState.sowDropdown,
							currentQueueDropdown: initialState.currentQueueDropdown
						};
					}
					case GET_SOW_DROPDOWN: {
						return {
							...state,
							sowDropdown: action.sowDropdown
						};
					}
					case GET_LAYERS_DROPDOWN: {
						return {
							...state,
							layersDropdown: action.layersDropdown
						};
					}
					case GET_TYPE_DROPDOWN: {
						return {
							...state,
							typeDropdown: action.typeDropdown,
							detailedTypeDropdown: initialState.detailedTypeDropdown
						};
					}
					case GET_DETAILED_TYPE_DROPDOWN: {
						return {
							...state,
							detailedTypeDropdown: action.detailedTypeDropdown
						};
					}
					case GET_INCIDENT: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.incident }
							}
						};
					}
					case GET_INCIDENT_COMMENTS: {
						return {
							...state,
							incidentComments: action.incidentComments
						};
					}
					case GET_INCIDENT_FILES: {
						return {
							...state,
							incidentFiles: action.incidentFiles
						};
					}
					default: {
						return state;
					}
	}
};

export default incidentTrackerReducer;
